import { render } from "./CreditRequestList.vue?vue&type=template&id=4b98a0a8"
import script from "./CreditRequestList.vue?vue&type=script&lang=js"
export * from "./CreditRequestList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__